import { Component, ViewEncapsulation } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
  selector: 'app-unauthorized-v2',
  imports: [TranslocoModule],
  templateUrl: './unauthorized-v2.component.html',
  styleUrl: './unauthorized-v2.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class UnauthorizedV2Component {
  constructor(private readonly auth: AuthService) {}

  logout() {
    this.auth.startSignoutMainWindow();
  }
}
